/*
  Event page helpers (loaded by sections/event-hero.liquid next to event-page.css).

  Marquees: a constant speed in pixels per second regardless of how long the
  track is (the CSS loop is translateX(-50%) over a duplicated track, so a long
  hero track would otherwise fly past while a one-word title crawls). Mirrors
  the design-system prototype (kismet.js → duration = track width / speed).
  `data-speed` on .ep-marquee is px/s; the inline --ep-marquee-speed stays as
  the no-JS fallback.

  Photo download ([data-ep-dl] links, see .ep-dl in event-page.css): fetch the
  full-size file asking the CDN for JPEG — a bare `download` link would save
  the WebP the CDN negotiates for browsers — and save it under the link's
  `download` name. On iPhone/iPad hand the file to the share sheet instead, so
  "Save Image" reaches Photos rather than Files. Without JS the link itself
  downloads (same origin).
*/
(function () {
  function tune(mq) {
    var track = mq.querySelector('.ep-marquee__track');
    if (!track) return;
    var speed = parseFloat(mq.getAttribute('data-speed')) || 40;
    var distance = track.scrollWidth / 2; // one copy of the items
    if (!distance) return;
    mq.style.setProperty('--ep-marquee-speed', Math.max(8, Math.round(distance / speed)) + 's');
  }
  function all() { document.querySelectorAll('.ep-marquee').forEach(tune); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(all, 150); });
  document.addEventListener('shopify:section:load', all);
})();

(function () {
  if (!window.fetch || !window.URL || !URL.createObjectURL) return;
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  function saveBlob(blob, name) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-ep-dl]');
    if (!link) return;
    e.preventDefault();
    var name = link.getAttribute('download') || 'photo.jpg';
    link.setAttribute('aria-busy', 'true');
    fetch(link.href, { headers: { Accept: 'image/jpeg' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.blob(); })
      .then(function (blob) {
        var file = typeof File === 'function' ? new File([blob], name, { type: blob.type || 'image/jpeg' }) : null;
        if (isIOS && file && navigator.canShare && navigator.canShare({ files: [file] })) {
          return navigator.share({ files: [file] }).catch(function (err) {
            if (err && err.name === 'AbortError') return;
            saveBlob(blob, name);
          });
        }
        saveBlob(blob, name);
      })
      .catch(function () { window.open(link.href, '_blank', 'noopener'); })
      .then(function () { link.removeAttribute('aria-busy'); });
  });
})();
